import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, HostListener } from '@angular/core';
import { MainService } from '../../services/main.service';

declare let $;

@Component({
  selector: 'app-mpos-page',
  templateUrl: './mpos-page.component.html',
  styleUrls: ['./mpos-page.component.scss']
})
export class MposPageComponent implements OnInit {

  @ViewChild('homeSection') homeSection: ElementRef;
  @ViewChild('homeTriang') homeTriang: ElementRef;
  @ViewChild('homeImage') homeImage: ElementRef;
  @ViewChild('homeText') homeText: ElementRef;
  @ViewChild('challengeSection') challengeSection: ElementRef;
  @ViewChild('quoteText') quoteText: ElementRef;
  @ViewChild('benefitsSection') benefitsSection: ElementRef;
  @ViewChild('video1') video1: ElementRef;

  videos;
 
  constructor(private renderer: Renderer2,
              private mainService: MainService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.videos = [this.video1];
  }

  ngAfterViewInit() {
    this.homeScreenLaying();
    this.renderer.addClass(this.homeTriang.nativeElement, 'fadeInDown');
    this.renderer.addClass(this.homeImage.nativeElement, 'fadeInLeft');
    this.renderer.addClass(this.homeText.nativeElement, 'fadeIn');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset;

    if ( scrollPosition >= this.challengeSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.challengeSection.nativeElement, 'show');
      this.renderer.addClass(this.challengeSection.nativeElement, 'fadeIn');
    }
    if ( scrollPosition >= this.quoteText.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.quoteText.nativeElement, 'fadeInLeft');
    }
    if ( scrollPosition >= this.benefitsSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.benefitsSection.nativeElement, 'show');
      this.renderer.addClass(this.benefitsSection.nativeElement, 'fadeIn');
    }

    for (let i = 0; i < this.videos.length; i++) {
      if ((scrollPosition >= this.getDistanceToDocumentTop(this.videos[i].nativeElement) - (window.innerHeight / 2))
      && (scrollPosition <= this.getDistanceToDocumentTop(this.videos[i].nativeElement))) {
        if (this.videos[i].nativeElement.paused) {
          this.videos[i].nativeElement.muted = true;
          this.videos[i].nativeElement.play();
        }
      } else {
        if (!this.videos[i].nativeElement.paused) {
          this.videos[i].nativeElement.pause();
        }
      }
    }
  }

  private getDistanceToDocumentTop(element) {
    let yPosition = 0;
    while (element) {
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }
    return yPosition;
  }

  private homeScreenLaying() {
    const screenHeight = window.innerHeight;
    $('#blank').height(screenHeight * 0.1);
    $('#content').height(screenHeight * 0.9);
  }

  public getVideoUrl() {
    switch (this.mainService.getLanguage()) {
      case 'es':
      return 'assets/videos/mturn-video-es.mp4';
      case 'en':
      return 'assets/videos/mturn-video-en.mp4';
      case 'fr':
      return 'assets/videos/mturn-video-fr.mp4';
    }
  }

}
